export const RQ_USER_LOGIN_API = {
  url: 'v1/user/login',
  method: 'POST',
  auth: false,
};
